// react
import { ReactNode, createContext, useEffect, useState } from 'react';
import { OrderType } from 'types/order';

export type AspContextType = {
  isThanks: boolean;
  setIsThanks: (value: boolean) => void;
  order: OrderType | null;
  setOrder: (value: OrderType | null) => void;
};

type AspProviderProps = {
  children: ReactNode;
};

const AspContext = createContext<AspContextType | null>(null);

export const AspProvider = ({ children }: AspProviderProps) => {
  const [isThanks, setIsThanks] = useState<boolean>(false);
  const [order, setOrder] = useState<OrderType | null>(null);

  const AspContextValue = {
    isThanks,
    setIsThanks,
    order,
    setOrder
  };
  useEffect(() => {
    console.log('isThanks', isThanks);
  }, [isThanks]);

  return <AspContext.Provider value={AspContextValue}>{children}</AspContext.Provider>;
};

export default AspContext;
